module.exports = __webpack_public_path__ + "static/media/SERV AL CLI.3e9f01f7.png";